<template lang="pug">
    div
        // Deactivate account section
        div.setting
            div.deactivate
                div

                    // Deactivate account title
                    title-component.deactivateTitle(type="h5" :title="$t('managers.edit.settings.deactivate.title')")

                div.ml-3
                    // Switch (tooggle activate/deactivate account)
                    v-switch.c-switch(
                        :label="isDeactivated ? 'Yes' : 'No'"
                        v-model="isDeactivated"
                        :disabled="isLoading"
                        @change="toggleActivation"
                        color="action"
                        hide-details
                    )

            // Deactivate account description
            div.description {{ $t('managers.edit.settings.deactivate.description') }}

        // Horizontal line
        separator-component

        // Delete account section
        div.setting

            // Delete account title
            title-component(type="h5" :title="$t('managers.edit.settings.delete.title')")

            // Delete account description
            div.description.pb-2 {{ $t('managers.edit.settings.delete.description') }}

            // Delete account button
            button-component.ml-0(
                :action="() => deleteAccount(model.id)"
                :loading="isLoading"
                :disabled="isLoading"
                color="error"
                outline
            ) {{ $t('managers.edit.settings.delete.button') }}

        // Horizontal line
        separator-component

        // Reset account password section
        div

            // Reset account title
            title-component(type="h5" :title="$t('managers.edit.settings.reset.title')")

            // Reset account description
            div.description.pb-2 {{ $t('managers.edit.settings.reset.description') }}

            // Reset password button
            button-component.ml-0(
                :action="resetPassword"
                :loading="isLoading"
                :disabled="isLoading"
                color="white"
                outline
            ) {{ $t('managers.edit.settings.reset.button') }}
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';

    export default {
        components: {
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapFields('managers', {
                model: 'manager'
            }),
            ...mapGetters('managers', ['isLoading']),
            isDeactivated: {
                get: function () {
                    return !this.model.isActive;
                },
                set: function (newValue) {
                    this.model.isActive = !newValue;
                }
            }
        },
        methods: {
            ...mapActions('managers', [
                'resetPassword',
                'deleteAccount',
                'updateStatus'
            ]),

            /**
             * Activate/Deactivate account
             */
            toggleActivation() {
                this.updateStatus();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .deactivate
        display: flex

    .deactivateTitle
        margin-top: 2px
</style>
